// Reconstructed from the published NovaVP application; original names unavailable where not recovered.
import { Fragment } from "react";
import * as React from "react";
import { usePathname } from "../lib/primitives.jsx";
import { isLanguage } from "./i18n.jsx";
import { analyticsEnabled } from "../lib/integrations.js";
var measurementId = `G-Z03VVMW988`,
  collectEndpoint = `https://metrics.novavp.site/collect`,
  pulseEndpoint = `https://metrics.novavp.site/pulse`,
  consentKey = `novavp-analytics-consent`,
  sessionKey = `novavp-analytics-session`,
  attributionKey = `novavp-analytics-attribution`,
  ownerCookie = `novavp_metrics_owner=1`,
  consentCopy = {
    fr: {
      title: `Mesure d'audience`,
      text: `Avec ton accord, Google Analytics et notre outil privé mesurent les visites, les clics et un préfixe d'IP, jamais l'adresse complète.`,
      accept: `Accepter`,
      refuse: `Refuser`,
    },
    en: {
      title: `Audience measurement`,
      text: `With your consent, Google Analytics and our private tool measure visits, clicks and an IP prefix, never the full IP address.`,
      accept: `Accept`,
      refuse: `Refuse`,
    },
    es: {
      title: `Medición de audiencia`,
      text: `Con tu consentimiento, Google Analytics y nuestra herramienta privada miden visitas, clics y un prefijo de IP, nunca la dirección completa.`,
      accept: `Aceptar`,
      refuse: `Rechazar`,
    },
    de: {
      title: `Reichweitenmessung`,
      text: `Mit deiner Zustimmung messen Google Analytics und unser privates Analysetool Besuche, Klicks und ein IP-Präfix, niemals die vollständige Adresse.`,
      accept: `Zustimmen`,
      refuse: `Ablehnen`,
    },
    it: {
      title: `Misurazione dell’audience`,
      text: `Con il tuo consenso, Google Analytics e il nostro strumento privato misurano visite, clic e un prefisso IP, mai l’indirizzo completo.`,
      accept: `Accetta`,
      refuse: `Rifiuta`,
    },
    nl: {
      title: `Bezoekersmeting`,
      text: `Met jouw toestemming meten Google Analytics en onze privéanalyse bezoeken, klikken en een IP-prefix, nooit het volledige adres.`,
      accept: `Accepteren`,
      refuse: `Weigeren`,
    },
  };
function loadGoogleAnalytics() {
  if (!analyticsEnabled()) return;
  if (document.querySelector(`script[data-novavp-ga]`)) return;
  ((window.dataLayer = window.dataLayer || []),
    (window.gtag = (...e) => window.dataLayer.push(e)),
    window.gtag(`js`, new Date()),
    window.gtag(`config`, measurementId, {
      anonymize_ip: true,
    }));
  let e = document.createElement(`script`);
  ((e.async = true),
    (e.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`),
    (e.dataset.novavpGa = `true`),
    document.head.appendChild(e));
}
function getSessionId() {
  let e = sessionStorage.getItem(sessionKey);
  if (e) return e;
  let t = crypto.randomUUID().replaceAll(`-`, ``);
  return (sessionStorage.setItem(sessionKey, t), t);
}
function getDeviceType() {
  let e = window.innerWidth;
  return e < 768 ? `mobile` : e < 1100 ? `tablet` : `desktop`;
}
function getAttribution() {
  let e = sessionStorage.getItem(attributionKey);
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      sessionStorage.removeItem(attributionKey);
    }
  let t = new URL(window.location.href),
    n = null;
  try {
    let e = document.referrer ? new URL(document.referrer).hostname : null;
    n = e && e !== window.location.hostname ? e : null;
  } catch {
    n = null;
  }
  let r = {
    source: t.searchParams.get(`utm_source`),
    medium: t.searchParams.get(`utm_medium`),
    campaign: t.searchParams.get(`utm_campaign`),
    referrer_host: n,
  };
  return (sessionStorage.setItem(attributionKey, JSON.stringify(r)), r);
}
var y = null;
function b() {
  if (y) return y;
  let e = new URL(window.location.href),
    t = null;
  try {
    let e = document.referrer ? new URL(document.referrer).hostname : null;
    t = e && e !== window.location.hostname ? e : null;
  } catch {
    t = null;
  }
  let n = e.searchParams.get(`utm_source`),
    r = e.searchParams.get(`utm_medium`),
    i = e.searchParams.get(`utm_campaign`);
  return (
    !n &&
      [`gclid`, `gbraid`, `wbraid`].some((t) => e.searchParams.has(t)) &&
      ((n = `google_ads`), (r ||= `cpc`), (i ||= `auto-tagged`)),
    !n &&
      e.searchParams.has(`msclkid`) &&
      ((n = `microsoft_ads`), (r ||= `cpc`), (i ||= `auto-tagged`)),
    (y = {
      source: n,
      medium: r,
      campaign: i,
      referrer_host: t,
    }),
    y
  );
}
function x(e) {
  let t = (e.source || e.referrer_host || ``).toLowerCase(),
    n = (e.medium || ``).toLowerCase();
  return [`cpc`, `ppc`, `paid`, `paidsearch`, `display`, `video`].some((e) =>
    n.includes(e),
  ) || t.includes(`_ads`)
    ? `Paid search`
    : n.includes(`email`) || t.includes(`mail`)
      ? `Email`
      : [
            `youtube`,
            `tiktok`,
            `instagram`,
            `facebook`,
            `twitter`,
            `x.com`,
            `discord`,
            `twitch`,
          ].some((e) => t.includes(e))
        ? `Social`
        : [`google`, `bing`, `duckduckgo`, `yahoo`, `ecosia`, `qwant`].some(
              (e) => t.includes(e),
            )
          ? n === `cpc`
            ? `Paid search`
            : `Organic search`
          : t
            ? `Referral`
            : `Direct`;
}
function S() {
  let e = navigator.userAgent;
  return /bot|crawler|spider|headless/i.test(e)
    ? `Bot`
    : /Edg\//.test(e)
      ? `Edge`
      : /OPR\//.test(e)
        ? `Opera`
        : /SamsungBrowser\//.test(e)
          ? `Samsung Internet`
          : /Firefox\//.test(e)
            ? `Firefox`
            : /Chrome\//.test(e)
              ? `Chrome`
              : /Safari\//.test(e)
                ? `Safari`
                : `Other`;
}
function C() {
  let e = navigator.userAgent;
  return /Windows/i.test(e)
    ? `Windows`
    : /Android/i.test(e)
      ? `Android`
      : /iPhone|iPad|iPod/i.test(e)
        ? `iOS`
        : /CrOS/i.test(e)
          ? `ChromeOS`
          : /Mac OS X|Macintosh/i.test(e)
            ? `macOS`
            : /Linux/i.test(e)
              ? `Linux`
              : `Other`;
}
var w = null,
  T = {
    startedAt: Date.now(),
    scrollDepth: 0,
    pointerMoves: 0,
    keyCount: 0,
    hiddenCount: 0,
    sentScroll: new Set(),
  };
function E() {
  return navigator.connection;
}
function D() {
  if (!w) {
    let e = navigator.userAgentData,
      t = navigator.userAgent;
    w = {
      user_agent: t.slice(0, 240),
      browser: S(),
      os: C(),
      platform: navigator.platform || null,
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
      pixel_ratio: window.devicePixelRatio || 1,
      hardware_concurrency: navigator.hardwareConcurrency || null,
      device_memory: navigator.deviceMemory || null,
      max_touch_points: navigator.maxTouchPoints || 0,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
      languages: (navigator.languages || [navigator.language])
        .filter(Boolean)
        .slice(0, 6)
        .join(`,`),
      webdriver: !!navigator.webdriver,
      cookies_enabled: navigator.cookieEnabled,
      color_scheme: window.matchMedia?.(`(prefers-color-scheme: light)`).matches
        ? `light`
        : `dark`,
      touch:
        navigator.maxTouchPoints > 0 ||
        !!window.matchMedia?.(`(pointer: coarse)`).matches,
      headless:
        !!navigator.webdriver || /HeadlessChrome|PhantomJS|Headless/i.test(t),
      vendor: navigator.vendor || null,
      pdf_viewer: !!navigator.pdfViewerEnabled,
      history_length: Math.min(window.history.length || 0, 1e3),
      dnt: navigator.doNotTrack || null,
      reduced_motion: !!window.matchMedia?.(`(prefers-reduced-motion: reduce)`)
        .matches,
      pointer: window.matchMedia?.(`(pointer: fine)`).matches
        ? `fine`
        : window.matchMedia?.(`(pointer: coarse)`).matches
          ? `coarse`
          : `none`,
      hover: window.matchMedia?.(`(hover: hover)`).matches ? `hover` : `none`,
      ua_mobile: typeof e?.mobile == `boolean` ? e.mobile : null,
      ua_brands:
        e?.brands
          ?.map((e) => e.brand)
          .filter(Boolean)
          .slice(0, 6)
          .join(`, `) || null,
    };
  }
  let e = E();
  return {
    ...w,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    outer: `${window.outerWidth || 0}x${window.outerHeight || 0}`,
    connection: e?.effectiveType || null,
    downlink: e?.downlink ?? null,
    rtt: e?.rtt ?? null,
    save_data: !!e?.saveData,
    tz_offset: new Date().getTimezoneOffset(),
    scroll_depth: T.scrollDepth,
    active_seconds: Math.round((Date.now() - T.startedAt) / 1e3),
    pointer_moves: T.pointerMoves,
    key_count: T.keyCount,
    hidden_count: T.hiddenCount,
    visible: document.visibilityState === `visible`,
  };
}
function O() {
  let e = window.screen?.width || window.innerWidth || 0;
  return e
    ? e < 600
      ? `small`
      : e < 1024
        ? `medium`
        : e < 1600
          ? `large`
          : `wide`
    : `unknown`;
}
function k() {
  let e = performance.getEntriesByType(`navigation`)[0];
  return [`navigate`, `reload`, `back_forward`, `prerender`].includes(
    e?.type || ``,
  )
    ? e.type
    : `unknown`;
}
function A(e, t) {
  if (!analyticsEnabled()) return;
  if (document.cookie.split(`;`).some((e) => e.trim() === ownerCookie)) return;
  let n = new URL(window.location.href),
    r = b(),
    i = localStorage.getItem(consentKey),
    a = JSON.stringify({
      event_kind: e,
      consent_state: t || (i === `accepted` || i === `refused` ? i : `unknown`),
      path: n.pathname,
      source: r.source,
      medium: r.medium,
      campaign: r.campaign,
      referrer_host: r.referrer_host,
      channel: x(r),
      device: getDeviceType(),
      browser: S(),
      operating_system: C(),
      screen_group: O(),
      navigation_type: k(),
      language: document.documentElement.lang.split(`-`)[0] || `fr`,
    });
  navigator.sendBeacon?.(
    pulseEndpoint,
    new Blob([a], {
      type: `text/plain;charset=UTF-8`,
    }),
  ) ||
    fetch(pulseEndpoint, {
      method: `POST`,
      headers: {
        "Content-Type": `text/plain;charset=UTF-8`,
      },
      body: a,
      keepalive: true,
      credentials: `include`,
    });
}
function j(e, t) {
  if (!analyticsEnabled()) return;
  if (
    localStorage.getItem(consentKey) !== `accepted` ||
    document.cookie.split(`;`).some((e) => e.trim() === ownerCookie)
  )
    return;
  let n = new URL(window.location.href),
    r = getAttribution(),
    i = Array.isArray(t.items) ? t.items : [],
    a = i[0] && typeof i[0] == `object` ? i[0] : {},
    o = (typeof a.item_id == `string` ? a.item_id : ``).match(/(\d+)$/),
    s =
      typeof t.value == `number`
        ? t.value
        : typeof a.price == `number`
          ? a.price
          : null,
    l = [t.detail, t.label, t.network, t.method].find(
      (e) => typeof e == `string` && e.trim(),
    ),
    d = JSON.stringify({
      event: e,
      session_id: getSessionId(),
      path: n.pathname,
      referrer_host: r.referrer_host,
      source: r.source,
      medium: r.medium,
      campaign: r.campaign,
      device: getDeviceType(),
      language:
        typeof t.language == `string`
          ? t.language
          : document.documentElement.lang || `fr`,
      pack_vp: o ? Number(o[1]) : null,
      value_cents: s === null ? null : Math.round(s * 100),
      detail: typeof l == `string` ? l.trim().slice(0, 120) : null,
      visitor: D(),
    });
  navigator.sendBeacon?.(
    collectEndpoint,
    new Blob([d], {
      type: `text/plain;charset=UTF-8`,
    }),
  ) ||
    fetch(collectEndpoint, {
      method: `POST`,
      headers: {
        "Content-Type": `text/plain;charset=UTF-8`,
      },
      body: d,
      keepalive: true,
      credentials: `include`,
    });
}
var M = 0,
  N = {
    label: ``,
    at: 0,
  };
function P(e) {
  let t = e.getAttribute(`aria-label`) || e.getAttribute(`title`);
  return t?.trim()
    ? t.trim().slice(0, 120)
    : (e.textContent || ``).replace(/\s+/g, ` `).trim().slice(0, 120);
}
function F() {
  let e = (e) => {
    if (Date.now() - M < 250) return;
    let t = e.target?.closest(`a, button, summary, [role='button']`);
    if (!t || t.closest(`.analyticsConsent`)) return;
    let n = P(t);
    n &&
      ((N.label === n && Date.now() - N.at < 400) ||
        ((N = {
          label: n,
          at: Date.now(),
        }),
        j(`ui_click`, {
          label: n,
          language: document.documentElement.lang.split(`-`)[0] || `fr`,
        })));
  };
  return (
    document.addEventListener(`click`, e),
    () => document.removeEventListener(`click`, e)
  );
}
function I() {
  let e = document.documentElement,
    t = Math.max(1, e.scrollHeight - window.innerHeight);
  return Math.min(100, Math.round((window.scrollY / t) * 100));
}
function L() {
  let e = 0,
    t = () => {
      T.scrollDepth = Math.max(T.scrollDepth, I());
      for (let e of [25, 50, 75, 100])
        T.scrollDepth >= e &&
          !T.sentScroll.has(e) &&
          (T.sentScroll.add(e),
          j(`scroll_depth`, {
            detail: `${e}%`,
            language: document.documentElement.lang.split(`-`)[0] || `fr`,
          }));
    },
    n = () => {
      T.pointerMoves += 1;
    },
    r = () => {
      T.keyCount += 1;
    },
    i = () => {
      Date.now() - e < 1e3 ||
        ((e = Date.now()),
        (T.hiddenCount += 1),
        j(`page_hide`, {
          detail: `${Math.round((Date.now() - T.startedAt) / 1e3)}s · scroll ${T.scrollDepth}%`,
          language: document.documentElement.lang.split(`-`)[0] || `fr`,
        }));
    },
    a = () => {
      document.visibilityState === `hidden` && i();
    },
    o = window.setInterval(() => {
      document.visibilityState === `visible` &&
        ((T.pointerMoves < 1 && T.keyCount < 1 && T.scrollDepth < 1) ||
          j(`session_ping`, {
            detail: `${Math.round((Date.now() - T.startedAt) / 1e3)}s · ${T.pointerMoves} mv`,
            language: document.documentElement.lang.split(`-`)[0] || `fr`,
          }));
    }, 2e4);
  return (
    document.addEventListener(`scroll`, t, {
      passive: true,
    }),
    document.addEventListener(`pointermove`, n, {
      passive: true,
    }),
    document.addEventListener(`keydown`, r),
    document.addEventListener(`visibilitychange`, a),
    window.addEventListener(`pagehide`, i),
    t(),
    () => {
      (window.clearInterval(o),
        document.removeEventListener(`scroll`, t),
        document.removeEventListener(`pointermove`, n),
        document.removeEventListener(`keydown`, r),
        document.removeEventListener(`visibilitychange`, a),
        window.removeEventListener(`pagehide`, i));
    }
  );
}
function trackAnalyticsEvent(e, t = {}) {
  if (!analyticsEnabled()) return;
  ((M = Date.now()), window.gtag?.(`event`, e, t), j(e, t));
}
function AnalyticsConsent() {
  let e = usePathname(),
    [t, n] = React.useState(null),
    [s, c] = React.useState(`fr`),
    l = React.useRef(null),
    d = React.useRef(null);
  (React.useEffect(() => {
    let e = () => {
      let e = document.documentElement.lang.split(`-`)[0];
      c(isLanguage(e) ? e : `fr`);
    };
    e();
    let t = new MutationObserver(e);
    t.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [`lang`],
    });
    let r = localStorage.getItem(consentKey),
      a = window.setTimeout(() => n(r), 0);
    return (
      r === `accepted` && loadGoogleAnalytics(),
      () => {
        (window.clearTimeout(a), t.disconnect());
      }
    );
  }, []),
    React.useEffect(() => {
      let t = e || window.location.pathname;
      d.current !== t && ((d.current = t), A(`landing`));
    }, [e]),
    React.useEffect(() => {
      if (t !== `accepted`) return;
      loadGoogleAnalytics();
      let n = e || window.location.pathname;
      if (
        l.current !== n &&
        ((l.current = n),
        j(`page_view`, {}),
        new URLSearchParams(window.location.search).get(`payment`) ===
          `success`)
      ) {
        let e = `novavp-checkout-return:${n}${window.location.search}`;
        sessionStorage.getItem(e) ||
          (sessionStorage.setItem(e, `1`), j(`checkout_return`, {}));
      }
      (T.sentScroll.clear(), (T.scrollDepth = 0));
      let r = F(),
        i = L();
      return () => {
        (r(), i());
      };
    }, [t, e]));
  let f = (e) => {
    (localStorage.setItem(consentKey, e),
      n(e),
      A(e === `accepted` ? `consent_accept` : `consent_refuse`, e),
      e === `accepted` && loadGoogleAnalytics());
  };
  if (t) return null;
  let p = consentCopy[s];
  return (
    <aside
      className={`analyticsConsent`}
      role={`dialog`}
      aria-labelledby={`analytics-consent-title`}
      aria-live={`polite`}
    >
      <div>
        <strong id={`analytics-consent-title`}>{p.title}</strong>
        <p>{p.text}</p>
      </div>
      <div className={`analyticsConsentActions`}>
        <button className={`consentRefuse`} onClick={() => f(`refused`)}>
          {p.refuse}
        </button>
        <button className={`consentAccept`} onClick={() => f(`accepted`)}>
          {p.accept}
        </button>
      </div>
    </aside>
  );
}
export { AnalyticsConsent as default, trackAnalyticsEvent };
